import { on } from "@ngrx/store";
import { DeveloperState } from "../developer.state";
import { AutoArchiveActions } from "./auto-archive.actions";
import { PagesStore } from "../../../pages.state";

// **************************************************************************
// HELPER: Update developer state within PagesStore
// **************************************************************************

function withDeveloper(state: PagesStore, updater: (developer: DeveloperState) => DeveloperState): PagesStore {
    return { ...state, developer: updater(state.developer) };
}

// **************************************************************************
// AUTO-ARCHIVE REDUCER (array format for PagesStore)
// **************************************************************************

// *** PREVIEW ***
const loadPreview = on(AutoArchiveActions.loadPreview, (state: PagesStore) => withDeveloper(state, developerState => ({
    ...developerState,
    autoArchive: {
        ...developerState.autoArchive,
        loading: { ...developerState.autoArchive.loading, loadingPreview: true },
    },
    error: null,
})));

const loadPreviewSuccess = on(AutoArchiveActions.loadPreviewSuccess, (state: PagesStore, { result }) => withDeveloper(state, developerState => ({
    ...developerState,
    autoArchive: {
        ...developerState.autoArchive,
        preview: result,
        loading: { ...developerState.autoArchive.loading, loadingPreview: false },
    },
    error: null,
})));

const loadPreviewFailure = on(AutoArchiveActions.loadPreviewFailure, (state: PagesStore, { error }) => withDeveloper(state, developerState => ({
    ...developerState,
    autoArchive: {
        ...developerState.autoArchive,
        loading: { ...developerState.autoArchive.loading, loadingPreview: false },
    },
    error,
})));

const clearPreview = on(AutoArchiveActions.clearPreview, (state: PagesStore) => withDeveloper(state, developerState => ({
    ...developerState,
    autoArchive: {
        ...developerState.autoArchive,
        preview: undefined,
    },
})));

// *** EXECUTE ***
const execute = on(AutoArchiveActions.execute, (state: PagesStore) => withDeveloper(state, developerState => ({
    ...developerState,
    autoArchive: {
        ...developerState.autoArchive,
        result: undefined,
        loading: { ...developerState.autoArchive.loading, executing: true },
    },
    error: null,
})));

const executeSuccess = on(AutoArchiveActions.executeSuccess, (state: PagesStore, { result }) => withDeveloper(state, developerState => ({
    ...developerState,
    autoArchive: {
        ...developerState.autoArchive,
        result,
        preview: undefined, // Clear preview after successful execution
        loading: { ...developerState.autoArchive.loading, executing: false },
    },
    error: null,
})));

const executeFailure = on(AutoArchiveActions.executeFailure, (state: PagesStore, { error }) => withDeveloper(state, developerState => ({
    ...developerState,
    autoArchive: {
        ...developerState.autoArchive,
        loading: { ...developerState.autoArchive.loading, executing: false },
    },
    error,
})));

const clearResult = on(AutoArchiveActions.clearResult, (state: PagesStore) => withDeveloper(state, developerState => ({
    ...developerState,
    autoArchive: {
        ...developerState.autoArchive,
        result: undefined,
    },
})));

export const autoArchiveReducer = [
    loadPreview,
    loadPreviewSuccess,
    loadPreviewFailure,
    clearPreview,
    execute,
    executeSuccess,
    executeFailure,
    clearResult,
];
